import React, { Fragment } from 'react'

import {
  AuthorDetail,
  PostHeader,
  QuoteBlock,
  PostParagraph,
  PostImageBlock,
  PostHero,
  PostSlideshow,
} from './'
import { InnerHtml } from '../global'
import { Advertisement } from '../advertisement/Advertisement'
import { useIsMobileView } from '../../utils'

const PostFlexContent = ({ post }) => {
  const isMobileView = useIsMobileView()
  const categoryId = post?.categories?.cats?.[0]?.id;

  const adplacement =
    categoryId === 'dGVybToxMjk4NQ=='
      ? 'betong'
      : categoryId === 'dGVybToy' 
      ? 'arkitekt'
      : null; 

  const {
    postFlexContent: {
      addBlock,
      headerType,
      customHeader,
      subheader = '',
      imagePosition,
    },
    author: { details },
    categories: { cats },
    featuredImage,
    title,
    date,
    legacyContent,
  } = post

  const placeElement = index => {
    let offset
    headerType === 'hero'
      ? subheader?.length > 1
        ? (offset = 2)
        : (offset = 1)
      : subheader?.length > 1
      ? (offset = 3)
      : (offset = 2)
    return { gridRow: index + offset }
  }

  return (
    <>
      {/* Blog 'B' tag in corner of hero img where appropriate */}
      {cats &&
        cats[0]['name'].toLowerCase().includes('blog') &&
        headerType === 'hero' && (
          <div className="blog-tag">
            <div className="blog-tag__inner">
              <h3>B</h3>
            </div>
          </div>
        )}
      {/* End 'B' tag element */}

      <PostHero
        type={headerType}
        header={customHeader || title}
        date={date}
        image={featuredImage?.image}
        cats={cats}
        imagePosition={imagePosition}
      />
      <div className={`post-flex-content ${headerType}`}>
        <PostHeader
          type={headerType}
          header={customHeader || title}
          date={date}
          image={featuredImage?.image}
          cats={cats}
        />
        <AuthorDetail authorDetails={details} />

        {legacyContent && (
          <InnerHtml
            className="post-paragraph legacy"
            content={legacyContent}
          />
        )}

        {subheader !== '' && (
          <PostParagraph
            size="large"
            content={subheader}
            style={placeElement(-1)}
          />
        )}

        <Advertisement height={isMobileView ? '226px' : '400px'} adplacement={adplacement}/>

        {addBlock?.map((block, idx) => {
          const { image, paragraphImage, quote, content, slideshow } = block

          return (
            <Fragment key={idx}>
              {content && (
                <PostParagraph
                  header={block.header}
                  size={block.size}
                  content={content}
                  image={paragraphImage}
                  style={placeElement(idx + 1)}
                />
              )}
              {image && (
                <PostImageBlock
                  src={image.sourceUrl}
                  alt={image.altText}
                  caption={image.caption}
                  description={image.description}
                  fullWidth={block.size === 'full'}
                  style={placeElement(idx + 1)}
                />
              )}
              {slideshow && (
                <PostSlideshow
                  slideshow={slideshow}
                  style={placeElement(idx + 1)}
                />
              )}
              {quote && (
                <QuoteBlock content={quote} style={placeElement(idx + 1)} />
              )}
            </Fragment>
          )
        })}
      </div>
    </>
  )
}

export default PostFlexContent
